export default "__VITE_ASSET__BoTic0rJ__"